export default __webpack_public_path__ + "static/media/paseos.ae8d7149.png";